import { Nav } from "react-bootstrap";
import "./Menu.scss";

export default (props) => {
  const cls = props.className ? props.className : "";
  return (
    <>
    <div className="Menu-content-margin"></div>
    <Nav {...props} className={`Menu ${cls}`} defaultActiveKey="/" as="ul">
      {props.children}
    </Nav>
    </>
  );
};
